import script from "./PlanosRepository.vue?vue&type=script&lang=js"
export * from "./PlanosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__